import React, { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { postProductPaginatedDR } from '../../../Api'
import useStore from '../ProductStore/Store'
import buildQuery from '../ProductQueryBuild'
import Name from './Name/Name'
import styles from './styles.module.css'
import Brand from './Brand/Brand'
import PrimaryCategories from './PrimaryCategories/PrimaryCategories'
import ExpandedFilters from '../ExpandedFilters/ExpandedFilters'
import { CircularProgress } from '@material-ui/core'
import BaseAlert from '../../Snackbar/NewImplementations/BaseAlert/BaseAlert'

export default function SearchFilters () {
  const {
    isQueryLoading,
    name,
    brand,
    primaryCategories,
    rawCategory,
    brandManufacturer,
    GTIN,
    SKUS,
    taxonomyLevel1,
    taxonomyLevel2,
    taxonomyLevel3,
    rentalPrice,
    firstRender,
    setFirstRender,
    page,
    setPage,
    setIsQueryLoading,
    setQueryStore,
    setDataResults,
    mostRecentPriceDate,
    description,
    reviews,
    reviewsRating,
    recordRecency,
    featureKeyword,
    requiredFields,
    reviewsRangeQuery,
    domain,
    mostRecentPriceIsSale,
    taxonomy,
    price,
    priceWarranty,
    categoryWildCard,
    color,
    categoriesWithParenthesis,
    featuresWithKey,
    manufacturerNumber
  } = useStore()

  const [errorAlert, setErrorAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: undefined,
    actions: []
  })

  const [query, setQuery] = useState() // State to store the query string

  const [searchFilterRequest] = useMutation(
    ({ page, query }) => postProductPaginatedDR(page, query),
    {
      onMutate: () => {
        // This will fire just before the mutation function is fired, so we can set isLoading to true here.
        setIsQueryLoading(true)
      },
      onSuccess: data => {
        if (data?.data?.errors || data.status >= 400) {
          setQueryStore(query)
          const errMsg = data?.data?.errors?.[0] || 'Something went wrong'

          if (errMsg.includes('product:paginate')) {
            setErrorAlert({
              open: true,
              title: 'Feature not enabled',
              body: `You need to enable "product.paginate" on your account to use this feature. Contact our team to request that this feature be enabled.`,
              color: '#000000',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setErrorAlert(e => ({ ...e, open: false }))
                },
                {
                  label: 'Contact support',
                  onClick: () => {
                    window.location.href = 'mailto:support@datafiniti.co'
                    setErrorAlert(e => ({ ...e, open: false }))
                  }
                }
              ]
            })
          } else if (errMsg === 'No results found for provided query.') {
            setErrorAlert({
              open: true,
              title: 'No results found',
              body: 'Try broadening your filters to find matches.',
              color: '#000000',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setErrorAlert(e => ({ ...e, open: false }))
                }
              ]
            })
          } else {
            setErrorAlert({
              open: true,
              title: 'Search Error',
              body: errMsg,
              color: '#EF3688',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setErrorAlert(e => ({ ...e, open: false }))
                }
              ]
            })
          }
          return
        }

        // success…
        setQueryStore(query)
        setDataResults(data)
      },
      onError: error => {},
      onSettled: () => {
        // This fires when onSuccess or onError is done, so we can set isLoading to false here.
        setIsQueryLoading(false)
      }
    }
  )

  useEffect(
    () => {
      if (!firstRender) {
        const newQuery = buildQuery(
          name,
          brand,
          primaryCategories,
          GTIN,
          SKUS,
          brandManufacturer,
          taxonomyLevel1,
          taxonomyLevel2,
          taxonomyLevel3,
          rawCategory,
          rentalPrice,
          mostRecentPriceDate,
          description,
          recordRecency,
          featureKeyword,
          requiredFields,
          reviewsRangeQuery,
          domain,
          mostRecentPriceIsSale,
          taxonomy,
          price,
          priceWarranty,
          categoryWildCard,
          color,
          categoriesWithParenthesis,
          featuresWithKey,
          manufacturerNumber
        )
        setQuery({ query: newQuery })
        setPage(1)
      } else {
        setFirstRender(false)
      }
    },
    /* eslint-disable-line react-hooks/exhaustive-deps */ [
      name,
      brand,
      primaryCategories,
      GTIN,
      SKUS,
      brandManufacturer,
      taxonomyLevel1,
      taxonomyLevel2,
      taxonomyLevel3,
      rawCategory,
      rentalPrice,
      mostRecentPriceDate,
      description,
      reviews,
      reviewsRating,
      recordRecency,
      featureKeyword,
      requiredFields,
      reviewsRangeQuery,
      domain,
      mostRecentPriceIsSale,
      taxonomy,
      price,
      priceWarranty,
      categoryWildCard,
      color,
      categoriesWithParenthesis,
      featuresWithKey,
      manufacturerNumber
    ]
  )

  useEffect(
    () => {
      if (!firstRender) {
        const searchFilterRequestFunction = () => {
          searchFilterRequest({ page, query })
        }

        if (query) {
          // Ensure query is set before making the request
          searchFilterRequestFunction()
        }
      }
    },
    /* eslint-disable-line react-hooks/exhaustive-deps */ [
      query,
      searchFilterRequest,
      page
    ]
  )

  useEffect(() => {
    return () => setFirstRender(true)
  }, [setFirstRender])

  return (
    <div>
      <h1 className={styles.searchFilterProduct}>Search filters</h1>
      <div className={styles.containerFilters}>
        <Name />
        <Brand />
        <PrimaryCategories />
        <ExpandedFilters />

        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          {isQueryLoading ? (
            <CircularProgress
              disableShrink
              size={25}
              style={{ color: '#065E88', marginBottom: '5px' }}
            />
          ) : (
            ''
          )}
        </div>
      </div>
      <BaseAlert
        open={errorAlert.open}
        title={errorAlert.title}
        body={errorAlert.body}
        color={errorAlert.color}
        style={{ width: '320px' }}
        actions={errorAlert.actions}
        onClose={() => setErrorAlert(e => ({ ...e, open: false }))}
      />
    </div>
  )
}
